(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["signoria-investor-navigation"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('si-investor-navigation'))customElements.define('si-investor-navigation',class extends HTMLElement{
 connectedCallback(){
  if(this.started)return;this.started=true;
  this.root=this.closest('.si-investor-page');if(!this.root)return;
  this.mobile=this.querySelector('.si-mobile-navigation');this.media=matchMedia('(max-width:989px)');
  this.resize=()=>{this.mobile.open=!this.media.matches;};this.resize();this.media.addEventListener('change',this.resize);
  this.click=e=>{const b=e.target.closest('[data-year-filter],[data-reset]');if(!b)return;this.apply(b.hasAttribute('data-reset')?'all':b.dataset.yearFilter,true);};this.addEventListener('click',this.click);
  this.refresh=()=>requestAnimationFrame(()=>{if(this.isConnected)this.build();});document.addEventListener('shopify:section:load',this.refresh);document.addEventListener('shopify:section:unload',this.refresh);
  this.select=()=>this.apply('all',false);document.addEventListener('shopify:block:select',this.select);
  if(document.readyState==='loading'){this.onReady=()=>this.build();document.addEventListener('DOMContentLoaded',this.onReady,{once:true});}else this.build();
 }
 disconnectedCallback(){this.media?.removeEventListener('change',this.resize);this.removeEventListener('click',this.click);document.removeEventListener('shopify:section:load',this.refresh);document.removeEventListener('shopify:section:unload',this.refresh);document.removeEventListener('shopify:block:select',this.select);document.removeEventListener('DOMContentLoaded',this.onReady);this.started=false;}
 build(){
  this.cards=[...this.root.querySelectorAll('.si-doc[data-financial-year]')];
  const values=this.cards.map(c=>/^20\d{2}-\d{2}$/.test(c.dataset.financialYear)?c.dataset.financialYear:'unspecified');this.cards.forEach((c,i)=>c.dataset.filterYear=values[i]);
  const years=[...new Set(values.filter(v=>v!=='unspecified'))].sort().reverse();
  const bar=this.querySelector('.si-investor-filters');bar.hidden=years.length===0;
  this.buttons=this.querySelector('.si-year-buttons');this.buttons.replaceChildren();
  this.options=['all',...years,...(values.includes('unspecified')?['unspecified']:[])];
  for(const v of this.options){const b=document.createElement('button');b.type='button';b.dataset.yearFilter=v;b.textContent=v==='all'?this.dataset.all:v==='unspecified'?this.dataset.unspecified:this.dataset.fy+' '+v;b.setAttribute('aria-pressed','false');this.buttons.append(b);}
  const requested=this.current||new URL(location.href).searchParams.get('financial_year')||'all';this.apply(this.options.includes(requested)?requested:'all',false);
 }
 apply(year,write){
  if(!this.cards)return;this.current=year;let count=0;
  for(const c of this.cards){c.hidden=year!=='all'&&c.dataset.filterYear!==year;if(!c.hidden)count++;}
  for(const group of this.root.querySelectorAll('.signoria-documents')){const section=group.closest('.shopify-section');if(section)section.hidden=![...group.querySelectorAll('.si-doc')].some(c=>!c.hidden);}
  this.buttons.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.yearFilter===year)));
  this.querySelector('.si-filter-count').textContent=count+' '+this.dataset.count;this.querySelector('.si-filter-empty').hidden=count!==0;
  if(write){const url=new URL(location.href);if(year==='all')url.searchParams.delete('financial_year');else url.searchParams.set('financial_year',year);history.replaceState(null,'',url);}
 }
});

  } catch(e) { console.error(e); }
})();
})();
